import { Gallery } from 'Slices/Settings/GalleriesSlice'
import { isNonEmptyString } from './StringHelpers'
import { getDistinctValues } from './ArrayHelper'

const generateGalleryName = (virtualId: number) => {
  const galleryName = 'Gallery ' + virtualId
  return galleryName
}

const getNextVirtualId = (galleries: Gallery[]) => {
  const virtualIds = galleries.filter(gallery => gallery.virtualId).map(e => e.virtualId)
  const nextVirtualId = virtualIds.length > 0 ? Math.min(...virtualIds) - 1 : -1
  return nextVirtualId
}

const checkGalleriesNames = (galleries: Gallery[]) => {
  const mappedNames = galleries.map(e => e.name).filter(e => isNonEmptyString(e))
  return getDistinctValues(mappedNames).length === galleries.length
}

const isBaseGallery = (id: Number) => {
  return id === 1
}

const retrieveImageUrl = (images: any, imageId: Number) => {
  return images.find(x => x.id === imageId).url
}

const retrieveGalleryIdFromDroppableId = (droppableId: string): string => {
  //droppableId for droppable container is set as:
  //gallery-{galleryId}
  const droppableIdSplit = droppableId.split('-')
  return droppableIdSplit[1]
}

const retrieveImageIdFromDraggableId = (draggableId: string): string => {
  //draggableId from droppable container that is not preview box is set as:
  //gallery-{galleryId}-img-{imageId}
  const draggableIdSplit = draggableId.split('-')
  return draggableIdSplit[3]
}

const reorderImages = (images, startIndex, endIndex, galleryImage = null) => {
  const result = [...images]
  const [removed] = result.splice(startIndex, 1)
  if (galleryImage) {
    if (removed) {
      result.splice(endIndex, 0, galleryImage, removed)
    } else {
      result.splice(endIndex, 0, galleryImage)
    }
  } else {
    result.splice(endIndex, 0, removed)
  }

  return result
}

const sortByPriority = images => {
  return images.sort((a, b) => {
    return (a.priority as number) - (b.priority as number)
  })
}

export {
  generateGalleryName,
  isBaseGallery,
  retrieveImageUrl,
  retrieveGalleryIdFromDroppableId,
  retrieveImageIdFromDraggableId,
  reorderImages,
  sortByPriority,
  getNextVirtualId,
  checkGalleriesNames,
}
